import React from "react";
import { useNavigate } from "react-router-dom";

const InvalidPage = () => {
  const navigate = useNavigate();

  const handlePrevious = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate("/");
  };

  return (
    <div>
      <div className="bg-white rounded-lg p-8 mx-auto mb-8">
        <div className="flex flex-col items-center text-center py-12">
          <svg
            className="w-20 h-20 text-red-500 mb-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 className="text-2xl font-bold mb-4">Invalid Page</h2>
          <p className="text-gray-600 mb-8 max-w-md">
            The page you are trying to access is invalid or has expired. Please
            return to the previous step or go to Home Page.
          </p>
          <div className="flex space-x-4">
            <button
              className="px-6 py-2 border border-gray-300 rounded-md text-gray-700"
              onClick={handlePrevious}
            >
              Previous
            </button>
            <button
              className="px-6 py-2 bg-black text-white rounded-md"
              onClick={handleHome}
            >
              Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvalidPage;
